export const REGIONS = [
  'Žilinský',
  'Trnavský',
  'Trenčiansky',
  'Prešovský',
  'Nitriansky',
  'Košický',
  'Bratislavský',
  'Banskobystrický',
];

export const AGE_GROUPS = [
  '00-17',
  '18-19',
  '20-24',
  '25-29',
  '30-34',
  '35-39',
  '40-44',
  '45-49',
  '50-54',
  '55-59',
  '60-64',
  '65-69',
  '70-74',
  '75-79',
  '80-84',
  '85-n',
];

export const VACCINES = ['Registrovaná', 'Neregistrovaná (Sputnik V)'];

export const DOSES = ['Prvá', 'Druhá' /*, 'Tretia'*/];

export const REGION_OPTIONS = REGIONS.map((region) => ({
  label: region,
  value: region,
}));

export const AGE_GROUP_OPTIONS = AGE_GROUPS.map((ageGroup) => ({
  label: ageGroup,
  value: ageGroup,
}));

export const DOSE_OPTIONS = DOSES.map((dose, index) => ({
  label: dose,
  value: index,
}));

export const VACCINE_OPTIONS = VACCINES.map((vaccine, index) => ({
  label: vaccine,
  value: index,
}));
